module.exports = __webpack_public_path__ + "img/51-l.f8055ae3.png";